import React from "react";

const LoadMoreButton = ({ onClick }) => {
  return (
    <div className="text-center mt-5">
      <button className="load-more-btn" onClick={onClick}>
        Load More
      </button>
    </div>
  );
};

export default LoadMoreButton;